import { Img, Stack, Text } from '@chakra-ui/react';
import meat from '../../../assets/meat.png';
import { useNavigate } from 'react-router-dom';
import { PROTECTED_PATHS } from '../../../app/constants';
import { dynamicPathhandler } from '../../../components/utils/dynamicPathHandler';

const OffersCard = (props) => {
  const navigate = useNavigate();
  const { OFFER_JOINT_ONE } = PROTECTED_PATHS;
  const parentPath = dynamicPathhandler(OFFER_JOINT_ONE);

  return (
    <Stack mx='2' onClick={() => navigate(`${parentPath}/${props._id}`)}>
      <Img
        h='100px'
        w='120px'
        borderRadius='5px'
        src={props?.imageUrl[0] || meat}
        alt={props?.itemName}
      />
      <Text textAlign={'center'} fontSize='12px' color='#000' fontWeight='500'>
        {props.itemName}
      </Text>
      <Text
        m='0 !important'
        textAlign={'center'}
        fontSize='12px'
        color='#000'
        fontWeight='500'
      >
        &#8358;{' '}
        <Text as='span' fontSize='14px' fontWeight='600'>
          {props.price}
        </Text>{' '}
        per share
      </Text>
    </Stack>
  );
};

export default OffersCard;
